export enum EBentoOrderForm {
  WEB = 1,
  MOBILE = 2,
  FB = 3,
  ANDROID = 4,
  IOS = 5,
  WEB_POS = 6,
  MOBILE_POS = 8,
  TABLET_POS = 9,
  OPEN_API = 10,
  FAST_CHECKOUT = 11,
  LAZADA = 12,
  SHOPEE_IMPORT = 13,
  LAZADA_IMPORT = 14,
  CART_BUILDER = 15,
  SHOPEE = 16,
  ARISLAB_IMPORT = 17,
  DEEPLE_IMPORT = 18,
  BENTOWEB_IMPORT = 19,
  JD = 20,
  LINE_SHOPPING = 21,
  TIKTOK_SHOP = 22,
}
